import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../../Containers/Config/index.js';
import { GET_LEDGER_LIST, GET_LEDGER_LIST_SUCCESS, GET_LEDGER_LIST_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* getLedgerList({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ledgers`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_LEDGER_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_LEDGER_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_LEDGER_LIST_ERROR, payload: error });
  }
}

export function* watchgetLedgerList() {
  yield takeEvery(GET_LEDGER_LIST, getLedgerList);
}

function* getLedgerListSaga() {
  yield all([fork(watchgetLedgerList)]);
}

export default getLedgerListSaga;
